import * as React from "react";
import HorizontalGroup from "./HorizontalGroup";
import HorizontalCollapse from "./HorizontalCollapse";
import HorizontalItem from "./HorizontalItem";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
// import { RouterConfigData } from "@crema/types/models/Apps";
import { NavItemProps as RouterConfigData } from 'modules/routesConfig';
import routesConfigData from "modules/routesConfig";
import { SxProps } from "@mui/system";

type Props = {
  routesConfig?: RouterConfigData[];
};
// const HorizontalNav = ({ routesConfig }: Props ) => {
const HorizontalNav: React.FC<Props> = ({ routesConfig = routesConfigData }) => {
  return (
    <List className="navbarNav"
      disablePadding
      sx={(theme) => ({
        mx: '24px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.palette.text.primary,
        gap: '8px'
      })}
    >
      {routesConfig
        .filter(route => ![
          'Home',
          'Profilo',
        ].includes(route.id))
        .map((item: RouterConfigData) => (
        <React.Fragment key={item.id}>
          {item.type === "group" && (
            <HorizontalGroup item={item} nestedLevel={0} />
          )}

          {item.type === "collapse" && (
            <HorizontalCollapse item={item} nestedLevel={0} />
          )}

          {item.type === "item" && (
            <HorizontalItem item={item} nestedLevel={0} />
          )}

          {item.type === "divider" && <Divider sx={{ my: 5 }} />}
        </React.Fragment>
      ))}
    </List>
  );
};

export function isUrlInChildren(parent: RouterConfigData, url: string) {
  if (!parent.children) {
    return false;
  }

  for (let i = 0; i < parent.children.length; i++) {
    if (parent.children[i].children) {
      if (isUrlInChildren(parent.children[i], url)) {
        return true;
      }
    }

    if (
      parent.children[i].url === url ||
      url.includes(parent!.children![i].url!)
    ) {
      return true;
    }
  }

  return false;
}

export default HorizontalNav;

export const navListItemStyle: SxProps = {
  alignSelf: 'stretch',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
}
